import { render, staticRenderFns } from "./ManagementOrderDescriptions.vue?vue&type=template&id=648a7eda&scoped=true"
import script from "./ManagementOrderDescriptions.vue?vue&type=script&lang=js"
export * from "./ManagementOrderDescriptions.vue?vue&type=script&lang=js"
import style0 from "./ManagementOrderDescriptions.vue?vue&type=style&index=0&id=648a7eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648a7eda",
  null
  
)

export default component.exports